import React from "react";
import styled from "styles/styled_components";
import { format } from "date-fns";
import { any } from "ramda";
import { Maybe } from "true-myth";

import { dropLastCharacter } from "helpers/times";
import { ISchedule } from "types/schedules";

import {
  StyledHeader,
  StyledAction,
  StyledLeftAction,
} from "components/shared/flex_header";
import Button, { ButtonColor } from "components/shared/button";
import FiltersButton from "components/schedule/action_bar/filters_button";
import ScheduleMenu from "containers/schedule/schedule_menu_container";
import Title from "components/schedule/action_bar/title";
import Icon, { ICON_TYPE, ICON_COLOR } from "components/shared/icon";

const TIMESTAMP_FORMAT = "MM/DD hh:mma";

const StyledTimeStamp = styled.div`
  color: ${props => props.theme.colors.brandGray30};
  font-size: ${props => props.theme.text.size.tiny};
  margin: ${props => {
    const { xsmall } = props.theme.spacing;
    return `0 auto ${xsmall} `;
  }};
`;

interface IActionBar {
  dayView: Maybe<Date>;
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
  hasFiltersApplied: boolean;
  rawSchedule: ISchedule;
  publishedAt: Maybe<Date>;
  publicURL: string;
  onClickPublish: () => void;
}

function ActionBar({
  dayView,
  startDate,
  endDate,
  hasFiltersApplied,
  onClickPublish,
  publicURL,
  publishedAt,
  rawSchedule,
}: IActionBar) {
  const publishedTimeStamp = publishedAt
    .map(date =>
      dropLastCharacter(`Published ${format(date, TIMESTAMP_FORMAT)}`)
    )
    .unwrapOr("");

  const canPublish = any(person => !!person.shifts.length, rawSchedule.people);
  return (
    <div>
      <StyledHeader>
        <StyledLeftAction>
          <Title dayView={dayView} startDate={startDate} endDate={endDate} />
        </StyledLeftAction>
        <StyledAction>
          <ScheduleMenu publicURL={publicURL} />
        </StyledAction>
        <StyledAction>
          <FiltersButton hasFiltersApplied={hasFiltersApplied} />
        </StyledAction>
        <StyledAction>
          <Button
            label="Publish"
            buttonColor={ButtonColor.BLUE}
            disabled={!canPublish}
            onClick={onClickPublish}
            title={
              canPublish ? "" : "Add shifts to your schedule before publishing."
            }
            iconLeft={
              <Icon
                size="12px"
                type={ICON_TYPE.UPLOAD}
                color={ICON_COLOR.WHITE}
              />
            }
          />
          <StyledTimeStamp>{publishedTimeStamp}</StyledTimeStamp>
        </StyledAction>
      </StyledHeader>
    </div>
  );
}

export default ActionBar;
